import React from 'react';
import { Outlet, Link } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import { withParamsAndNavigate } from '../components/WithParamsAndNavigate';
import { PopModal } from '../components/PopModal';
import BaseCom from './BaseCom';
import './Layout.css';

class Layout extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            user: props.user
        }
    }


    componentDidUpdate(prevProps) {
        if (prevProps.user !== this.props.user)
            this.setState({ user: this.props.user });
    }

    render() {
        return (
            <>
                <ToastContainer position="top-center"
                    autoClose={1000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light" />
                <PopModal />
                <header>
                    <div className="container-fluid py-5">
                        <div className="d-flex align-items-center">
                            <img src="/img/icon.png" alt="" className="mx-3 img-fluid d-block" />
                            <img src="/img/logo.png" alt="" className="mx-3 img-fluid d-none d-md-block" />
                            <div className="flex-fill text-end">
                                <a href="https://www.mobilewoundcaremd.com" role="button" className="btn btn-custom p-2 px-4 me-3">EXIT SURVEY</a>
                            </div>
                        </div>
                    </div>
                </header>
                <main>
                    <div className="c-pagewrapper">
                        <Outlet />
                    </div>
                </main>
            </>
        );
    }
}

export default withParamsAndNavigate(Layout);
